import axios from 'axios';
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response && error.response.status === 401 && !error.config?.skipAuthLogout) {
        localStorage.removeItem("user");
        window.location.href = '/login?code=401';
    }
    return Promise.reject(error);
});

export default axios;
